/* eslint-disable  import/no-named-as-default, css-modules/no-unused-class  */
import { FC, useEffect, useRef } from 'react';
import styles from './progresses.module.scss';

const CourseProgressBorder: FC<{ percentage: number }> = ({ percentage }: { percentage: number }) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    useEffect(() => {
        if (canvasRef.current) {
            const canvas = canvasRef.current;
            const ctx = canvas?.getContext('2d');

            if (ctx) {
                const canvasWidth = canvas.width;
                const canvasHeight = canvas.height;
                const perimeter = (canvasWidth + canvasHeight) * 2;
                const borderLength = (percentage / 100) * perimeter;

                // Clear the canvas
                ctx.clearRect(0, 0, canvasWidth, canvasHeight);

                // Draw the rectangle border
                ctx.lineWidth = 14; // Border width in pixels
                ctx.strokeStyle = '#FB86B6'; // Border color

                // Top border
                if (borderLength > 0) {
                    ctx.beginPath();
                    ctx.moveTo(canvasWidth / 2, 0);
                    ctx.lineTo(Math.min(borderLength + canvasWidth / 2, canvasWidth), 0);
                    ctx.stroke();
                }

                // Right border
                if (borderLength > canvasWidth / 2) {
                    ctx.beginPath();
                    ctx.moveTo(canvasWidth, 0);
                    ctx.lineTo(canvasWidth, Math.min(borderLength - canvasWidth / 2, canvasHeight));
                    ctx.stroke();
                }

                // Bottom border
                if (borderLength > canvasWidth / 2 + canvasHeight) {
                    ctx.beginPath();
                    ctx.moveTo(canvasWidth, canvasHeight);
                    ctx.lineTo(
                        Math.max(canvasWidth - (borderLength - canvasWidth / 2 - canvasHeight), 0),
                        canvasHeight
                    );
                    ctx.stroke();
                }

                // Left border
                // Left border
                if (borderLength > canvasWidth * 1.5 + canvasHeight) {
                    ctx.beginPath();
                    ctx.moveTo(0, canvasHeight);
                    ctx.lineTo(0, Math.max(canvasHeight - (borderLength - (canvasWidth * 1.5 + canvasHeight)), 0));
                    ctx.stroke();
                }

                if (borderLength > canvasWidth * 1.5 + canvasHeight * 2) {
                    ctx.beginPath();
                    ctx.moveTo(0, 0);
                    ctx.lineTo(Math.min(borderLength - (canvasWidth * 1.5 + canvasHeight * 2), canvasWidth / 2), 0);
                    ctx.stroke();
                }
            }
        }
    }, [percentage]);

    return <canvas ref={canvasRef} className={styles.rectangle}></canvas>;
};

export default CourseProgressBorder;
